import * as React from 'react'

type Params = {
  page?: number
  search?: string
  pageSize?: number
  simplified?: string
}

export default function useSelectPagination<T>(hasMore: boolean): {
  onMenuScrollToBottom: () => void
  onInputChange: (input: string) => void
  options: T[]
  setOptions: React.Dispatch<React.SetStateAction<T[]>>
  params: Params
} {
  const [params, setParams] = React.useState({
    page: 1,
    search: '',
    pageSize: 25,
  })
  const [options, setOptions] = React.useState<T[]>([])

  const onMenuScrollToBottom = () => {
    if (!hasMore) return

    setParams((params) => ({ ...params, page: params.page + 1 }))
  }

  const onInputChange = (input: string) => {
    setOptions([])
    setParams({ page: 1, search: input, pageSize: 25 })
  }

  return {
    onMenuScrollToBottom,
    onInputChange,
    options,
    setOptions,
    params,
  }
}
